import { Button, FormLabel, Group, IconCrossCircle, Input, Textarea } from '@screentone/core';
import clonedeep from 'lodash.clonedeep';

import { PageModule } from 'data/generated/graphql';
import styles from '../PageModule.module.scss';

interface PageModuleTextProps {
  pageModule: PageModule;
  onChange: (newPageModule: PageModule) => void;
  viewOnly?: boolean;
}

export const PageModuleText = ({ pageModule, onChange, viewOnly = false }: PageModuleTextProps) => {
  const handleChangeStringField =
    (fieldKey: 'mainText' | 'secondaryText') => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const newPageModule = clonedeep(pageModule);
      if (newPageModule.uiModuleFields?.textModule) {
        newPageModule.uiModuleFields.textModule[fieldKey] = e.target.value;
      }
      onChange(newPageModule);
    };

  const handleClearField = (fieldKey: 'mainText' | 'secondaryText') => () => {
    const newPageModule = clonedeep(pageModule);
    if (newPageModule.uiModuleFields?.textModule) {
      newPageModule.uiModuleFields.textModule[fieldKey] = '';
    }
    onChange(newPageModule);
  };

  return (
    <>
      <FormLabel key="mainText" label="Main Text" fullWidth>
        <Group gap="xs" className={styles.inputContainer}>
          <Input
            placeholder="Enter main text"
            value={pageModule.uiModuleFields?.textModule?.mainText}
            margin={{ bottom: 'sm' }}
            onChange={handleChangeStringField('mainText')}
            disabled={viewOnly}
          />
          {!viewOnly && (
            <Button
              tertiary
              icon={IconCrossCircle}
              className={styles.deleteIcon}
              onClick={handleClearField('mainText')}
            />
          )}
        </Group>
      </FormLabel>
      <FormLabel key="secondaryText" label="Secondary Text" fullWidth margin={{ top: 'sm' }}>
        <Group gap="xs" className={styles.inputContainer}>
          <Textarea
            placeholder="Enter Secondary Text"
            value={pageModule.uiModuleFields?.textModule?.secondaryText}
            margin={{ bottom: 'sm' }}
            onChange={handleChangeStringField('secondaryText')}
            disabled={viewOnly}
          />
          {!viewOnly && (
            <Button
              tertiary
              icon={IconCrossCircle}
              className={styles.deleteIcon}
              onClick={handleClearField('secondaryText')}
            />
          )}
        </Group>
      </FormLabel>
    </>
  );
};
